module.exports = __webpack_public_path__ + "img/img07.6729472b.png";